import moment from "moment";
import React, { useState } from "react";
import DocumentModal from "../DocumentModal";
import { Row, Col } from 'antd';
import { Spinner } from "@public/ui-toolkit";

function FundDeck({ decks, onCreateAuditLogs, deckLoading = false, portal = "allocator" }) {

  const [fileSource, setFileSource] = useState(null);
  const [docModalVisible, setDocModalVisible] = useState(false);

  const newString = (value) => {
    if (value.length > 26) {
      return value.substring(0, 25) + "...";
    }
    return value;
  };

  const onOpenModal = () => setDocModalVisible(true);

  const onCreateAuditLog = (fileName, fileSrc) => {
    if (portal === "allocator") {
      const value = {
        actionName: "View Cloud Document",
        parameters: { fileName: fileName }
      }
      onCreateAuditLogs(value);
    }

    setFileSource(fileSrc)
    onOpenModal();
  }

  return (
    <Row className="component mt-3">
      {!deckLoading ? (
        <Col span={24} className="component-body">
          {
            decks?.length ? (
              <Row>
                {decks?.map((deck, index) => {
                  return (
                    <Col style={{ borderRadius: "10px" }} span={7} key={index} className="card doc-card mr-3 mb-1 force-overflow">
                      <Row
                        className="card-header document-header p-3"
                        style={{ borderRadius: "10px 10px 0px 0px" }}
                      >
                        <h5
                          className="d-inline"
                          style={{ color: "#fff" }}
                          title={deck.fileName}
                        >
                          {`${newString(deck.fileName)}`}
                        </h5>
                      </Row>
                      <Row className="card-body text-center p-2 mt-3" onClick={() => onCreateAuditLog(deck.fileName, deck.url)}>
                        <Col
                          className="col"
                          data-bs-toggle="modal"
                          data-bs-target={`#exampleModal${index}`}
                          style={{ cursor: "pointer" }}

                        >
                          <i className="fa fa-file-pdf-o fa-4x" title="View Fund Document"></i>
                          <p className="mt-3">View Fund Document</p>
                        </Col>
                      </Row>
                      <hr />
                      <p style={{ textAlign: "right", marginRight: "10px" }}>Uploaded on : {moment(deck?.creationTime).format("DD MMM YYYY")}</p>
                    </Col>
                  )
                })}
              </Row>
            ) : (
              <Row style={{ marginTop: "75px" }}>
                <Col
                  className="alert alert-primary text-center w-75 d-flex m-auto justify-content-center"
                  role="alert"
                >
                  Document Cloud are not available.
                </Col>
              </Row>
            )}
        </Col>
      ) :
        (
          <Col span={24} className="text-center">
            <Spinner />
          </Col>
        )}

      {docModalVisible &&
        <DocumentModal
          src={fileSource}
          open={docModalVisible}
          onClose={() => setDocModalVisible(false)}
          modalSize={"1000px"} />
      }
    </Row>


  );
}

export default FundDeck;
